import React from 'react';
import PropTypes from 'prop-types';

class MultiSelect extends React.Component {
    constructor(props) {
        super(props);
        this.refreshSelectControl = this.refreshSelectControl.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.displayName = 'MultiSelect';
        this.uuid = "multi_select_" + (Math.random().toPrecision(5) * 100000);
        
    }
    refreshSelectControl() {
        var select = $('.'+this.uuid)
        var selected = [];

        select.multiselect('destroy');
        select.multiselect({
            onChange : this.handleSelectChange
        });
        console.log(this.props.selected);
        select.multiselect('select', this.props.selected);
    }
    handleSelectChange(option,checked,select) {
        var id = $(option).val();

        for (var i = 0; i < this.props.options.length; i++) {
            if(this.props.options[i]._id == id) {
                if(checked)
                    this.props.add(id);
                else
                    this.props.remove(id);
                break;
            }
        };
    }
    render() {
        var uuid = this.uuid;
        return (
        	<select className={"form-control " + this.uuid} multiple="multiple" data-plugin-multiselect >
        		{this.props.options.map(function (option) {                    
        			return (
                        <option key={option._id} value={option._id}>{option.name}</option>
                    )
        		})}				
			</select>
        );
    }
    componentDidUpdate(prevProps, prevState) {
        console.log("MultiSelect Did Update.");
        this.refreshSelectControl();     
    }
}

MultiSelect.propTypes = {
	options : PropTypes.arrayOf(PropTypes.shape({
        	_id : PropTypes.string.isRequired,
        	name : PropTypes.string.isRequired,
        }))
};
export default MultiSelect;



// WEBPACK FOOTER //
// ./src/browser/components/forms/MultiSelect.js